import React from "react"
import MobileApps from "@views/mobile-apps"
import SEO from "@components/SEO"

const MobileAppsPage = () => (
  <div>
    <SEO
      title="EngineID - iOS and Android Apps"
      keywords={[
        `engineid`,
        `security`,
        `authenticator`,
        `mobile`,
        `ios`,
        `android`
      ]}
    />
    <MobileApps />
  </div>
)

export default MobileAppsPage
